import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Game from '../views/Game.vue';
import JoinUsCampus from '../views/JoinUsCampus.vue'
import CampusJobDetails from '../views/CampusJobDetails.vue'
import JoinUsSocial from '../views/JoinUsSocial.vue'
import SocialJobDetails from '../views/SocialJobDetails.vue'
import About from '../views/About.vue';
import Privacy from "../views/Privacy.vue";
import Terms from "../views/Terms.vue";


Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: '/'
  },
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  // {
  //   path: '/#game',
  //   name: 'game',
  //   hash:"#game",
  // },
  // {
  //   path: '/#about',
  //   name: 'about',
  //   hash:"#about",
  // },
  // {
  //   path: '/#connect',
  //   name: 'connect',
  //   hash:"#connect",
  // },

]

const router = new VueRouter({
  mode: 'history', // 使用 hash 模式
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash, // 根据 hash 定位
        behavior: 'smooth', // 平滑滚动
      };
    } else if (savedPosition) {
      return savedPosition; // 返回到之前的位置
    } else {
      return { x: 0, y: 0 }; // 默认滚动到顶部
    }
  },
});

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default router



// WEBPACK FOOTER //
// ./src/router/index.js